const PLACEHOLDER_BUSINESS_NAME_RE =
  /^\s*(?:\d+\s+files?\s+uploaded|uploaded file)\s*$/i;

/** Upload-batch labels written as a stand-in name before classification. */
export function isPlaceholderBusinessName(
  name: string | null | undefined,
): boolean {
  if (name == null) return true;
  const trimmed = name.trim();
  if (!trimmed) return true;
  return PLACEHOLDER_BUSINESS_NAME_RE.test(trimmed);
}

/** First candidate that is a real business name (not blank / upload label). */
export function pickValuationBusinessName(
  ...candidates: Array<string | null | undefined>
): string | null {
  for (const candidate of candidates) {
    if (typeof candidate !== "string") continue;
    if (isPlaceholderBusinessName(candidate)) continue;
    return candidate.trim();
  }
  return null;
}

export function classifiedBusinessName(
  classification: unknown,
): string | null {
  if (!classification || typeof classification !== "object") return null;
  const biz = (
    classification as {
      businessIdentification?: { businessName?: unknown };
    }
  ).businessIdentification;
  const name = biz?.businessName;
  return typeof name === "string" ? pickValuationBusinessName(name) : null;
}

export function resolveValuationBusinessName(input: {
  businessName?: string | null;
  classificationResult?: unknown;
}): string | null {
  return pickValuationBusinessName(
    input.businessName,
    classifiedBusinessName(input.classificationResult),
  );
}

export function hasResearchableBusinessName(
  name: string | null | undefined,
): boolean {
  return !isPlaceholderBusinessName(name);
}
